/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import s from './Header.css';
import Link from '../Link';
import Navigation from '../Navigation';
import LanguageSwitcher from '../LanguageSwitcher';
import logoUrl from './logo-small.png';
import logoUrl2x from './logo-small@2x.png';
import logoInspire from './logo-inspire.png';
import s from './Header.scss';
import PageFontResizer from '../PageFontResizer';

import { connect } from 'react-redux';
import { setRuntimeVariable } from '../../actions/runtime';

const messages = defineMessages({
  bannerDesc: {
    id: 'header.banner.desc',
    defaultMessage: 'Complex web apps made easy',
    description: 'Description in header',
  },
});


class Header extends React.Component {

  render() {
    return (
      <nav className={'header'} style={{fontSize: this.props.fontSize + 'rem'}}>

        <div className={'col-xs-2'}>
          <PageFontResizer />
        </div>

        <div id={"navbar"} className={'col-xs-8'}>

          <div className={"navbar-header"}>
            <button type="button" className={"navbar-toggle collapsed"} data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
              <span className={"sr-only"}>Toggle navigation</span>
              <span className={"icon-bar"}></span>
              <span className={"icon-bar"}></span>
              <span className={"icon-bar"}></span>
            </button>
            <a className={"navbar-brand"} href="#" ><img src={logoInspire} alt="Inspire-hub" /></a>
          </div>

          <div className={'navContainer'}>
            <ul className={'navList'}>
              <li className={'active'}>
                <Link to="/">HOME</Link>
              </li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="administrator">Administrator</a></li>
              <li><FormattedMessage {...messages.bannerDesc} /></li>
            </ul>
          </div>

        </div>
        <div className={'col-xs-2'}>
          <LanguageSwitcher />
        </div>
      </nav>
    );
  }
}

export default withStyles(s)(Header);



// WEBPACK FOOTER //
// src/components/Header/Header.js